import $global from '@xt/client/store/global'
import type { ClasshourItem } from '@xt/client/entities/course-v2/types.d'
import type { Asset, Material, BaseTemplate, TopDirClasshourLayout, BottomDirClasshourLayout } from '../types.d'

export class TemplateTwenty implements BaseTemplate {
  /**
   * 当前课程进度 0 - 3
   */
  private taskSchedule: number
  /**
   * 头部课程(开学见面)是否已经发布
   */
  private withStartCourse: boolean
  /**
   * 尾部课程(小灶课)是否已经发布
   */
  private withEndCourse: boolean
  /**
   * 展示学习回顾
   */
  private showReview: boolean
  /**
   * 展示开课前请准备 与 学习回顾位置互斥
   */
  public showPrepare: boolean
  /**
   * 当前真实的课程进度索引，与taskSchedule相比 taskSchedule不会返回小灶课尾部课程的索引
   * 模版20  realCurrent: 0 - 21
   */
  public realCurrent: number

  constructor(options: {
    taskSchedule: number
    showReview: boolean
    showPrepare: boolean
    withStartCourse: boolean
    withEndCourse: boolean
    realCurrent: number
  }) {
    this.taskSchedule = options.taskSchedule
    this.showReview = options.showReview
    this.showPrepare = options.showPrepare
    this.withStartCourse = options.withStartCourse
    this.withEndCourse = options.withEndCourse
    this.realCurrent = options.realCurrent
  }

  private static assets: Record<string, Asset> = {
    'bg-style-v1': {
      url: `${$global.static}/images/course/pc/template/tpl-20/tpl-20-bg-style-v2.png`,
      width: 1352,
      height: 1163
    },
    'material-sprite': {
      url: `${$global.static}/images/course/pc/template/tpl-20/tpl-20-sprites-v1.png`,
      width: 406,
      height: 312
    },
    'material-review': {
      url: `${$global.static}/images/course/pc/bg-review-v1.png`,
      width: 248,
      height: 218
    }
  }

  getTemplateSize() {
    // 83
    return { width: 1352, height: 1433, marginTop: 32, marginBottom: 0, marginLeft: 100 }
  }

  getBottomMaterialConfigList(): Array<Array<Material>> {
    // 数字角标 【top, left】
    const numberIndex = [
      [219, 128],
      [280, 313],
      [271, 511],
      [312, 702],
      [340, 909],
      [459, 1079],
      [565, 946],
      [611, 819],
      [565, 697],
      [549, 511],
      [529, 325],
      [518, 115],
      [765, 115],
      [924, 220],
      [1049, 293],
      [932, 442],
      [936, 647],
      [1077, 667],
      [1094, 795],
      [1229, 848],
      [1127, 963],
      [1094, 1112]
    ]

    return [
      [
        {
          type: 'normal',
          ...TemplateTwenty.assets['bg-style-v1'],
          visible: true,
          name: 'bg',
          top: 68,
          left: 0
        }
      ],
      [
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.withStartCourse,
          name: 'bg-tpl_20_number_star',
          top: numberIndex[0][0],
          left: numberIndex[0][1],
          x: -362,
          y: -61,
          self: {
            width: 27,
            height: 27
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 1,
          name: 'bg-tpl_20_number_1',
          top: numberIndex[1][0],
          left: numberIndex[1][1],
          x: -173,
          y: -123,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 2,
          name: 'bg-tpl_20_number_2',
          top: numberIndex[2][0],
          left: numberIndex[2][1],
          x: -55,
          y: -205,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 3,
          name: 'bg-tpl_20_number_3',
          top: numberIndex[3][0],
          left: numberIndex[3][1],
          x: -5,
          y: -205,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 4,
          name: 'bg-tpl_20_number_4',
          top: numberIndex[4][0],
          left: numberIndex[4][1],
          x: -105,
          y: -205,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 5,
          name: 'bg-tpl_20_number_5',
          top: numberIndex[5][0],
          left: numberIndex[5][1],
          x: -205,
          y: -205,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 6,
          name: 'bg-tpl_20_number_6',
          top: numberIndex[6][0],
          left: numberIndex[6][1],
          x: -155,
          y: -205,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 7,
          name: 'bg-tpl_20_number_7',
          top: numberIndex[7][0],
          left: numberIndex[7][1],
          x: -262,
          y: -5,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 8,
          name: 'bg-tpl_20_number_8',
          top: numberIndex[8][0],
          left: numberIndex[8][1],
          x: -262,
          y: -61,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 9,
          name: 'bg-tpl_20_number_9',
          top: numberIndex[9][0],
          left: numberIndex[9][1],
          x: -262,
          y: -117,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 10,
          name: 'bg-tpl_20_number_10',
          top: numberIndex[10][0],
          left: numberIndex[10][1],
          x: -262,
          y: -173,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 11,
          name: 'bg-tpl_20_number_11',
          top: numberIndex[11][0],
          left: numberIndex[11][1],
          x: -312,
          y: -61,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 12,
          name: 'bg-tpl_20_number_12',
          top: numberIndex[12][0],
          left: numberIndex[12][1],
          x: -312,
          y: -5,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 13,
          name: 'bg-tpl_20_number_13',
          top: numberIndex[13][0],
          left: numberIndex[13][1],
          x: -312,
          y: -173,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 14,
          name: 'bg-tpl_20_number_14',
          top: numberIndex[14][0],
          left: numberIndex[14][1],
          x: -55,
          y: -261,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 15,
          name: 'bg-tpl_20_number_15',
          top: numberIndex[15][0],
          left: numberIndex[15][1],
          x: -312,
          y: -117,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 16,
          name: 'bg-tpl_20_number_16',
          top: numberIndex[16][0],
          left: numberIndex[16][1],
          x: -5,
          y: -261,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 17,
          name: 'bg-tpl_20_number_17',
          top: numberIndex[17][0],
          left: numberIndex[17][1],
          x: -105,
          y: -261,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 18,
          name: 'bg-tpl_20_number_18',
          top: numberIndex[18][0],
          left: numberIndex[18][1],
          x: -205,
          y: -261,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 19,
          name: 'bg-tpl_20_number_19',
          top: numberIndex[19][0],
          left: numberIndex[19][1],
          x: -155,
          y: -261,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent !== 20,
          name: 'bg-tpl_20_number_20',
          top: numberIndex[20][0],
          left: numberIndex[20][1],
          x: -255,
          y: -261,
          self: {
            width: 40,
            height: 46
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.withEndCourse,
          name: 'bg-tpl_20_number_star_end',
          top: numberIndex[21][0],
          left: numberIndex[21][1],
          x: -362,
          y: -61,
          self: {
            width: 27,
            height: 27
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.realCurrent > 0 && this.realCurrent < 21,
          name: 'bg-tpl_20_number_current',
          top: numberIndex[this.realCurrent][0],
          left: numberIndex[this.realCurrent][1],
          x: -362,
          y: -5,
          self: {
            width: 39,
            height: 46
          }
        }
      ]
    ]
  }

  getTopMaterialConfigList(): Array<Array<Material>> {
    const studentPositon = () => {
      switch (this.taskSchedule) {
        case 0:
          return { top: 242, left: 154 }
        case 1:
          return { top: 233, left: 413 }
        case 2:
          return { top: 240, left: 597 }
        case 3:
          return { top: 303, left: 772 }
        case 4:
          return { top: 329, left: 951 }
        case 5:
          return { top: 464, left: 1028 }
        case 6:
          return { top: 522, left: 848 }
        case 7:
          return { top: 512, left: 775 }
        case 8:
          return { top: 529, left: 596 }
        case 9:
          return { top: 507, left: 411 }
        case 10:
          return { top: 484, left: 213 }
        case 11:
          return { top: 529, left: 55 }
        case 12:
          return { top: 840, left: 115 }
        case 13:
          return { top: 948, left: 245 }
        case 14:
          return { top: 932, left: 366 }
        case 15:
          return { top: 875, left: 529 }
        case 16:
          return { top: 948, left: 673 }
        case 17:
          return { top: 1033, left: 702 }
        case 18:
          return { top: 1119, left: 799 }
        case 19:
          return { top: 1123, left: 909 }
        case 20:
          return { top: 1029, left: 1042 }
        default:
          throw new Error(`pos ${this.taskSchedule}`)
      }
    }

    return [
      [
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: true,
          name: 'bg-tpl_20_student',
          ...studentPositon(),
          x: -173,
          y: -5,
          self: {
            width: 79,
            height: 108
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule === 0,
          name: 'bg-tpl_20_material_01',
          top: 272,
          left: 98,
          x: -385,
          y: -263,
          self: {
            width: 16,
            height: 9
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule === 0,
          name: 'bg-tpl_20_material_02',
          top: 305,
          left: 146,
          x: -362,
          y: -238,
          self: {
            width: 16.5,
            height: 15
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 4,
          name: 'bg-tpl_20_material_03',
          top: 379,
          left: 746,
          x: -362,
          y: -181,
          self: {
            width: 16,
            height: 18.5
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 8,
          name: 'bg-tpl_20_material_04',
          top: 607,
          left: 755,
          x: -362,
          y: -263,
          self: {
            width: 13,
            height: 11.5
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 10,
          name: 'bg-tpl_20_material_05',
          top: 608,
          left: 504,
          x: -362,
          y: -125.5,
          self: {
            width: 27.5,
            height: 17.5
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 11,
          name: 'bg-tpl_20_material_06',
          top: 546,
          left: 201,
          x: -388,
          y: -209.5,
          self: {
            width: 12.5,
            height: 16
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 13,
          name: 'bg-tpl_20_material_07',
          top: 813,
          left: 90,
          x: -362,
          y: -284.5,
          self: {
            width: 16,
            height: 9
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 13,
          name: 'bg-tpl_20_material_08',
          top: 851,
          left: 82,
          x: -362,
          y: -209.5,
          self: {
            width: 16,
            height: 18.5
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 13,
          name: 'bg-tpl_20_material_09',
          top: 934,
          left: 146,
          x: -362,
          y: -98,
          self: {
            width: 27.5,
            height: 17.5
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 16,
          name: 'bg-tpl_20_material_10',
          top: 944,
          left: 572,
          x: -362,
          y: -153,
          self: {
            width: 17,
            height: 18
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 16,
          name: 'bg-tpl_20_material_11',
          top: 993,
          left: 607,
          x: -388,
          y: -181,
          self: {
            width: 12.5,
            height: 16
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.taskSchedule < 20,
          name: 'bg-tpl_20_material_12',
          top: 1185,
          left: 873,
          x: -312,
          y: -229,
          self: {
            width: 16,
            height: 9
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: true,
          name: 'bg-tpl_20_material_13',
          top: 1024,
          left: 1098,
          x: -305,
          y: -229,
          self: {
            width: 46,
            height: 39
          }
        }
      ],
      [
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-sprite'],
          visible: this.showPrepare,
          name: 'bg-tpl_20_prepare',
          top: 0,
          left: 1136,
          x: -5,
          y: -5,
          hover: {
            x: -89,
            y: -5
          },
          clickEventName: 'click-prepare',
          self: {
            width: 74,
            height: 190
          }
        },
        {
          type: 'sprite',
          ...TemplateTwenty.assets['material-review'],
          visible: this.showReview,
          name: 'bg-review',
          top: -22,
          left: 1102,
          x: -129,
          y: -5,
          hover: {
            x: -5,
            y: -5
          },
          clickEventName: 'click-review',
          self: {
            width: 114,
            height: 208
          }
        }
      ]
    ]
  }

  public getClasshourLayoutInfo(_item: ClasshourItem, index: number): TopDirClasshourLayout | BottomDirClasshourLayout {
    switch (index) {
      case 0:
        return { directionStyle: 'bottom', bottom: 1226, left: 61 } satisfies BottomDirClasshourLayout
      case 1:
        return { directionStyle: 'bottom', bottom: 1153, left: 253 } satisfies BottomDirClasshourLayout
      case 2:
        return { directionStyle: 'bottom', bottom: 1162, left: 451 } satisfies BottomDirClasshourLayout
      case 3:
        return { directionStyle: 'bottom', bottom: 1121, left: 642 } satisfies BottomDirClasshourLayout
      case 4:
        return { directionStyle: 'bottom', bottom: 1093, left: 848 } satisfies BottomDirClasshourLayout
      case 5:
        return { directionStyle: 'bottom', bottom: 973, left: 1018 } satisfies BottomDirClasshourLayout
      case 6:
        return { directionStyle: 'bottom', bottom: 868, left: 885 } satisfies BottomDirClasshourLayout
      case 7:
        return { directionStyle: 'top', top: 656, left: 758 } satisfies TopDirClasshourLayout
      case 8:
        return { directionStyle: 'bottom', bottom: 868, left: 637 } satisfies BottomDirClasshourLayout
      case 9:
        return { directionStyle: 'bottom', bottom: 884, left: 451 } satisfies BottomDirClasshourLayout
      case 10:
        return { directionStyle: 'bottom', bottom: 904, left: 264 } satisfies BottomDirClasshourLayout
      case 11:
        return { directionStyle: 'bottom', bottom: 915, left: 54 } satisfies BottomDirClasshourLayout
      case 12:
        return { directionStyle: 'bottom', bottom: 668, left: 54 } satisfies BottomDirClasshourLayout
      case 13:
        return { directionStyle: 'bottom', bottom: 509, left: 160 } satisfies BottomDirClasshourLayout
      case 14:
        return { directionStyle: 'top', top: 1094, left: 233 } satisfies TopDirClasshourLayout
      case 15:
        return { directionStyle: 'bottom', bottom: 501, left: 381 } satisfies BottomDirClasshourLayout
      case 16:
        return { directionStyle: 'bottom', bottom: 497, left: 586 } satisfies BottomDirClasshourLayout
      case 17:
        return { directionStyle: 'top', top: 1122, left: 607 } satisfies TopDirClasshourLayout
      case 18:
        return { directionStyle: 'bottom', bottom: 339, left: 735 } satisfies BottomDirClasshourLayout
      case 19:
        return { directionStyle: 'top', top: 1274, left: 788 } satisfies TopDirClasshourLayout
      case 20:
        return { directionStyle: 'bottom', bottom: 306, left: 903 } satisfies BottomDirClasshourLayout
      case 21:
        return { directionStyle: 'top', top: 1132, left: 1045 } satisfies TopDirClasshourLayout
      default:
        throw new Error(`${index}`)
    }
  }
}
